/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TabService } from '../../../core/services/tab.service';
import { LmsEventDetails } from './../../../core/model/lms-event-details.model';
import { LocoDetail } from './../../../core/model/loco-detail.model';
import { Tab } from './../../../core/model/tab.model';
import { AppUtilityService } from './../../../core/services/app-utility.service';
import { ConfigService } from './../../../core/services/config.service';
import { LmsLoaderService } from './../../../core/services/lms-loader.service';
import { MessageHandlerService } from './../../../core/services/message-handler.service';
import { LocoStatusService } from './../../../loco-status/shared/services/loco-status.service';



/**
 * @export
 * @class LocoStatusHeaderComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-loco-status-header',
  templateUrl: './loco-status-header.component.html',
  styleUrls: ['./loco-status-header.component.scss']
})

export class LocoStatusHeaderComponent implements OnInit {

  @Input() lastRefreshTime: string;
  @Input() tab: Tab;
  @Input() tabs: Tab[];
  @Input() locoStatusArr: Array<LocoDetail>;
  filteredLocoStatusArr: Array<LocoDetail>;
  displayLastRefershTime: string;
  @Output() refreshBtnEvent = new EventEmitter();
  configData: any;
  tabIndex: number;
  editMode: any;
  /**
   * Creates an instance of LocoStatusHeaderComponent.
   * @memberOf LocoStatusHeaderComponent
   */
  constructor(private locoStatusService: LocoStatusService,
    private lmsLoaderService: LmsLoaderService,
    private appUtilityService: AppUtilityService,
    private messageHandlerService: MessageHandlerService,
    private configService: ConfigService,
    private tabService: TabService) {
    this.configData = this.configService.getConfigData();
    this.tabIndex = this.configData.tabIndex.topTabs;
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LocoStatusHeaderComponent
   */
  ngOnInit() {
  }

  lmsEventHandler(lmsEventDetails: LmsEventDetails) {
    this.tabService.notifyChange(lmsEventDetails);
  }

  /**
   * Invoked for refresh loco status screen.
   * @memberOf LocoStatusHeaderComponent
   */
  refreshLocoStatus() {
    if (this.locoStatusArr) {
      const locoArr: Array<LocoDetail> = [];
      for (let i = 0; i < this.locoStatusArr.length; i++) {
        if (this.locoStatusArr[i].searcheLocomotiveIdentifier) {
          this.locoStatusArr[i].searcheLocomotiveIdentifier = this.appUtilityService.UIformatLocomotiveId(this.locoStatusArr[i].searcheLocomotiveIdentifier);
          locoArr.push(this.locoStatusArr[i]);
        }
      }
      this.locoStatusArr = locoArr;
      this.refreshBtnEvent.emit(this.locoStatusArr);
    }
  }
}
